import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "question-detail-container"
};
const _hoisted_2 = {
  class: "sorting-items-container"
};
const _hoisted_3 = ["onDragstart", "onDragenter", "onDrop"];
const _hoisted_4 = {
  class: "item-order-number"
};
const _hoisted_5 = {
  class: "item-detail-container"
};
const _hoisted_6 = {
  key: 0,
  class: "item-value"
};
const _hoisted_7 = {
  key: 1,
  class: "answer-image-container"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  key: 0,
  class: "answer-image-label"
};
const _hoisted_10 = {
  key: 0,
  class: "item-position-correction"
};
const _hoisted_11 = {
  class: "item-position-correction-circle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_quiz_question_label = _resolveComponent("quiz-question-label");
  const _component_quiz_answers_validation_alert = _resolveComponent("quiz-answers-validation-alert");
  const _component_quiz_question_correction_explanation = _resolveComponent("quiz-question-correction-explanation");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['quiz-sorting-question-container', {
      'result-mode': _ctx.isResultMode
    }])
  }, [_ctx.displayOverallVerdictIcon ? (_openBlock(), _createBlock(_component_icon, {
    key: 0,
    icon: _ctx.overallAnswersVerdictIcon,
    class: _normalizeClass(['question-overall-verdict-icon', _ctx.overallVerdictIconClass])
  }, null, 8, ["icon", "class"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createVNode(_component_quiz_question_label, {
    label: _ctx.questionCustomLabel || _ctx.question.label,
    "label-detail": _ctx.question?.information
  }, null, 8, ["label", "label-detail"]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.realtimeUserItemsSorting, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: item.position,
      class: _normalizeClass(['sorting-item-row', {
        'is-drag-over': index === _ctx.dragOverIndex
      }]),
      draggable: true,
      onDragstart: $event => _ctx.onDragStart(index),
      onDragenter: _withModifiers($event => _ctx.onDragEnter(index), ["prevent"]),
      onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _withModifiers($event => _ctx.onDrop(index), ["prevent"]),
      onDragend: _cache[1] || (_cache[1] =
      //@ts-ignore
      (...args) => _ctx.onDragEnd && _ctx.onDragEnd(...args))
    }, [_createElementVNode("span", _hoisted_4, _toDisplayString(item.position), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
      class: _normalizeClass(['item-value-block', _ctx.answerStatusClass(item)])
    }, [_createVNode(_component_icon, {
      class: "reorder-icon",
      icon: "drag-vertical"
    }), _ctx.getItemValue(item.itemId) ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getItemValue(item.itemId)), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
      src: _ctx.getItemImagePath(item.itemId),
      class: "answer-image"
    }, null, 8, _hoisted_8), _ctx.getItemImageLabel(item.itemId) ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.getItemImageLabel(item.itemId)), 1)) : _createCommentVNode("", true)])), _ctx.isResultMode ? (_openBlock(), _createBlock(_component_icon, {
      key: 2,
      class: _normalizeClass(['answer-status-icon', _ctx.answerStatusClass(item)]),
      icon: _ctx.answerStatusIcon(item)
    }, null, 8, ["class", "icon"])) : _createCommentVNode("", true)], 2), _ctx.shouldDisplayItemsSortingCorrection(item) ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getItemCorrectPosition(item.itemId)), 1)])) : _createCommentVNode("", true)])], 42, _hoisted_3);
  }), 128))]), _ctx.displayAnswersValidationAlert ? (_openBlock(), _createBlock(_component_quiz_answers_validation_alert, {
    key: 0,
    question: _ctx.question,
    class: "answers-validation-block",
    "answers-validation-state": _ctx.answersValidationState
  }, null, 8, ["question", "answers-validation-state"])) : _createCommentVNode("", true), _ctx.isResultMode && _ctx.question.correction ? (_openBlock(), _createBlock(_component_quiz_question_correction_explanation, {
    key: 1,
    class: "correction-explanation-block",
    "question-correction": _ctx.question.correction
  }, null, 8, ["question-correction"])) : _createCommentVNode("", true)])], 2);
}